import React from 'react';
import PropTypes from 'prop-types';

import MembersSearch from './member-search';
import { MembersSortFieldMobile } from '../member-sort-field';
import MembersFilterField from '../member-filter-field';
import styles from './member-header-mobile.scss';
import { XIcon } from '../icons/x-icon';
import { SearchIcon } from '../icons/search-icon';

const classNames = require('classnames');

export const SEARCH_BAR_EXPAND_TIME = 300;

export class MemberHeaderMobile extends React.Component {
  state = {
    searchExpanded: false,
    iconVisible: true,
    searchFocused: false,
  };

  sortRef = null;
  filterRef = null;

  handleSearchToggle = () => {
    if (this.state.searchExpanded) {
      this.setState({ searchExpanded: false, searchFocused: false });
      setTimeout(() => this.setState({ iconVisible: true }), SEARCH_BAR_EXPAND_TIME);
      this.props.onSearchChange();
    } else {
      this.setState({ searchExpanded: true, iconVisible: false });
      setTimeout(() => this.setState({ searchFocused: true }), SEARCH_BAR_EXPAND_TIME);
    }
  };

  renderSearchIcon = () => (
    <div className={classNames(styles.searchIconContainer, 'ma-all-members-header-border')}>
      <span className={styles.searchIcon}>
        <SearchIcon className="ma-members-list-icon-color" />
      </span>
    </div>
  );

  renderCloseIcon = () => {
    const containerClassName = classNames(
      styles.closeIconContainer,
      'ma-all-members-header-border',
      'ma-all-members-header-bg',
    );
    return (
      <div className={containerClassName} onClick={this.handleSearchToggle}>
        <span className={styles.closeIcon}>
          <XIcon size="small" className="ma-all-members-icon-stroke" />
        </span>
      </div>
    );
  };

  renderSearchBar = () => (
    <MembersSearch
      className={classNames('ma-all-members-header-bg', styles.search)}
      count={this.props.membersCount}
      displayCount={this.props.displayMembersCount}
      focusSearch={this.state.searchFocused}
      onChange={this.props.onSearchChange}
    />
  );

  getWidth = (ref) => (ref ? ref.clientWidth : 0);

  getSearchOffsetLeft = () => {
    const sortWidth = this.getWidth(this.sortRef);
    const filterWidth = this.getWidth(this.filterRef);
    const offset = this.state.searchExpanded ? sortWidth + filterWidth : 0;
    return `-${offset}px`;
  };

  renderSearch = () => {
    // eslint-disable-next-line react/prop-types
    const offsetDirection = this.props.isRtlLocale ? 'right' : 'left';
    return (
      <div className={classNames(styles.searchContainer, 'ma-primary-font-color', 'ma-fill-primary-text')}>
        <div
          className={styles.contentWrapper}
          onClick={!this.state.searchExpanded && this.handleSearchToggle}
          data-hook="am-search-button"
          style={{ [offsetDirection]: this.getSearchOffsetLeft() }}
        >
          {!this.state.iconVisible && this.renderSearchBar()}
          {!this.state.iconVisible && this.renderCloseIcon()}
          {this.state.iconVisible && this.renderSearchIcon()}
        </div>
      </div>
    );
  };

  renderFilter = () => (
    <div ref={(ref) => (this.filterRef = ref)}>
      <MembersFilterField
        className={classNames(styles.filter, 'ma-primary-font-color', 'ma-fill-primary-text')}
        value={this.props.filter}
        filters={this.props.filters}
        onChange={this.props.onFilterChange}
      />
    </div>
  );

  renderSort = () => (
    <div ref={(ref) => (this.sortRef = ref)}>
      <MembersSortFieldMobile
        className={styles.sort}
        value={this.props.sort}
        sorts={this.props.sorts}
        onChange={this.props.onSortChange}
      />
    </div>
  );

  render() {
    return (
      <div className={classNames(styles.content, 'ma-box', 'ma-all-members-header-border', 'ma-font-body-m')}>
        {this.renderFilter()}
        {this.props.displayMemberSortField && this.renderSort()}
        {this.renderSearch()}
      </div>
    );
  }
}

MemberHeaderMobile.propTypes = {
  sort: PropTypes.string.isRequired,
  sorts: PropTypes.object,
  onSortChange: PropTypes.func.isRequired,
  filter: PropTypes.string,
  filters: PropTypes.object,
  onFilterChange: PropTypes.func.isRequired,
  membersCount: PropTypes.number,
  displayMembersCount: PropTypes.bool,
  displayMemberSortField: PropTypes.bool,
  onSearchChange: PropTypes.func.isRequired,
};

export default MemberHeaderMobile;
